module.exports = __webpack_public_path__ + "img/sx.7ba4d18.svg";